import { useQuery } from '@tanstack/react-query';

import useMailboxService from 'src/modules/mailer/hooks/useMailboxService';
import useMailerDriver from 'src/modules/mailer/hooks/useMailerDriver';
import {
    MAILBOX_FOLDER_API,
    normalizeMailboxUnreadCount,
} from '../helpers';

export const MAILBOX_UNREAD_COUNT_QUERY_KEY = 'mailbox-fetch-unread-count';

const useMailboxUnreadCount = ({
    enabled = true,
    folder = MAILBOX_FOLDER_API.inbox,
} = {}) => {
    const service = useMailboxService();
    const { active } = useMailerDriver();
    const query = useQuery({
        queryKey: [MAILBOX_UNREAD_COUNT_QUERY_KEY, active, folder],
        queryFn: async () => {
            const payload = await service.fetchUnreadCount({
                folder,
            });

            return normalizeMailboxUnreadCount(payload);
        },
        enabled,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') {
                console.error(error);
            }
        },
    });

    return query.data || 0;
};

export default useMailboxUnreadCount;
